<template>
    <div v-if="enquiryTask !== null">
        <div class="grid-x list-row supply align-items sidebar-color" v-for="task in enquiryTask" :key="task.taskId" :class="businessAreaClass(task.businessAreaTypeId)">
            <div class="cell large-1">
                <icon class="task-svg medium-svg fill-primary" name="task" />
            </div>
            <div class="cell large-4 item truncate-fade truncate-fade-simple">
                <span>{{ task.taskName }}</span>
                <span v-if="task.address1">{{ task.address1 }}, <span v-if="task.address2">{{ task.address2 }},</span> {{ task.postalCode }} {{ task.city }}</span>
                <span v-else>Ingen adresse</span>
            </div>
            <div class="cell large-3 item">
                <span v-if="task.requisitionedCount">{{ task.requisitionedCount }} rekvirere<span v-if="task.requisitionedCount === 1">t</span><span v-if="task.requisitionedCount !== 1">de</span> aktivitet<span v-if="task.requisitionedCount > 1">er</span></span>
                <span v-else>Ingen rekvirerede aktiviteter</span>
                <span v-if="task.requestCount">{{ task.requestCount }} henvendelse<span v-if="task.requestCount > 1">r</span></span>
                <span v-else>Ingen henvendelser</span>
            </div>
            <div class="cell large-2 item truncate-fade">
                <span>{{ task.ownerUser }}</span>
                <span>{{ task.ownerOrganization }}</span>
            </div>
            <div class="cell large-2 item flexbox-center">
                <span class="task-status" :class="statusColor(task.status)">{{ task.status }}</span>
            </div>
            <router-link class="dashboard-list-link" :to="{ name: 'taskid', params: { id: task.taskId } }">
                <span class="visually-hidden">Åben henvendelse</span>
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'list-enquiry-tasks',
    computed: {
        ...mapGetters({
            enquiryTask: 'getEnquiryTask',
            selectedCaseworker: 'getSelectedCaseworker',
            supplyTypes: 'getSysBusinessAreaTypeList'
        })
    },
    methods: {
        businessAreaClass (businessAreaType) {
            const supplyType = this.supplyTypes.find(supplyType => supplyType.sysBusinessAreaTypeId === businessAreaType)

            if (supplyType) {
                return supplyType.systemName
            }
        },
        statusColor (status) {
            if (status) {
                if (status.toLowerCase() === 'i gang') {
                    return 'blue-status'
                }
                if (status.toLowerCase() === 'færdigmeldt') {
                    return 'green-status'
                }
                if (status.toLowerCase() === 'afsluttet') {
                    return 'gray-status'
                }
            }
            return 'blue-status'
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/list/list-enquiry-tasks.vue